import { render, staticRenderFns } from "./ArquivoUpdate.vue?vue&type=template&id=86ea2b08"
import script from "./ArquivoUpdate.vue?vue&type=script&lang=js"
export * from "./ArquivoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports